import React, { useEffect, useState } from "react";
import Recent from "../Notifications/Recent";
import Allocated from "../Notifications/Allocated";
import Closed from "../Notifications/Closed";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { useLocation } from "react-router-dom";
import { useAdmin } from "../../../components/Common/FilterContext/AdminPanelContext";
import StatusComp from "../../../components/StatusComp";

const CompanyNotifications = () => {
  const location = useLocation();
  const { savePageState, getPageState } = useAdmin();
  const pageKey = location.pathname;
  const tab = location.state?.tab;
  const saved = getPageState(pageKey);
  const [activeTab, setActiveTab] = useState(
    tab ? tab : saved?.activeTab || "Recent",
  );
  const [siteList, setSiteList] = useState(null);
  const [sites, setSites] = useState(saved?.sites || "");
  const [companies, setCompanies] = useState(null);
  console.log("savedSites", saved?.sites);
  console.log("sites", sites);

  // useEffect(() => {
  //   const stored = localStorage.getItem("Notifications");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab("Recent");
  //     localStorage.setItem("Notifications", JSON.stringify("Recent"));
  //   }
  // }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    savePageState(pageKey, {
      activeTab: type,
    });
  };

  const getSiteList = () => {
    get(URL.ACTIVE_SITE + "?knf_type=1")
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getSiteList();
  }, []);

  return (
    <div className="dashRightView">
      <StatusComp type={"Alert Notification"} />
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "Recent" ? "active" : ""}`}
          onClick={() => handleTab("Recent")}
        >
          New
        </button>
        <button
          className={`tab-btn ${activeTab === "Allocated" ? "active" : ""}`}
          onClick={() => handleTab("Allocated")}
        >
          Assigned
        </button>
        <button
          className={`tab-btn ${activeTab === "Closed" ? "active" : ""}`}
          onClick={() => handleTab("Closed")}
        >
          Closed
        </button>
      </div>

      <div>
        {activeTab === "Recent" && (
          <Recent
            site={"company"}
            siteList={siteList}
            setSiteList={setSiteList}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
        {activeTab === "Allocated" && (
          <Allocated
            site={"company"}
            siteList={siteList}
            setSiteList={setSiteList}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
        {activeTab === "Closed" && (
          <Closed
            site={"company"}
            siteList={siteList}
            setSiteList={setSiteList}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
      </div>
    </div>
  );
};

export default CompanyNotifications;
